import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, CardActions } from '@one-thd/sui-atomic-components';
import { showMobileLayout } from '../../constants/responsiveClassNames';
import DesktopCarousel from './DesktopCarousel';
import MobileCompactList from './MobileCompactList';
import { projectPropType } from '../dataModel';

const { arrayOf, number } = PropTypes;

const ProjectsActions = () => (
  <div className={classNames(showMobileLayout, 'sui-mt-auto')}>
    <CardActions>
      <Button fullWidth href="/projects">View All Projects</Button>
    </CardActions>
  </div>
);

const ProjectsContainer = ({ projects, maxMobileProjectSize, isCompactView }) => {
  return (
    <>
      <div
        data-testid="projects-container"
        className="sui-flex sui-flex-col sui-justify-start sui-grow"
      >
        {isCompactView ? (
          <MobileCompactList
            projects={projects}
            maxMobileProjectSize={maxMobileProjectSize}
          />
        ) : (
          <DesktopCarousel
            projects={projects}
          />
        )}
        <ProjectsActions />
      </div>
    </>
  );
};

ProjectsContainer.propTypes = {
  projects: arrayOf(projectPropType),
  maxMobileProjectSize: number,
  isCompactView: PropTypes.bool
};
ProjectsContainer.defaultProps = {
  projects: [],
  maxMobileProjectSize: 3,
  isCompactView: true
};
export default ProjectsContainer;
